import { initPostHog } from '@/lib/posthog'

void initPostHog()
